export const NL6 = {
  "All": "Alle",
  "active": "actief",
  "unread": "ongelezen",
  "Management report": "Managementrapport",
  "Certificate": "Certificaat",
  "Something went wrong. Please try again.": "Er is iets misgegaan. Probeer het opnieuw.",
  "An account with this email already exists.": "Er bestaat al een account met dit e-mailadres.",
  "Assessment not found": "Assessment niet gevonden",
  "Certificate not found": "Certificaat niet gevonden",
  "Client not found": "Klant niet gevonden",
  "Client profile not found": "Klantprofiel niet gevonden",
  "Current password is incorrect.": "Het huidige wachtwoord is onjuist.",
  "Email not found": "E-mailadres niet gevonden",
  "File not found": "Bestand niet gevonden",
  "Invalid email or password.": "Ongeldig e-mailadres of wachtwoord.",
  "Invalid payload": "Ongeldige gegevens",
  "Invalid session": "Ongeldige sessie",
  "Invalid status": "Ongeldige status",
  "New password must be different from the current password.": "Het nieuwe wachtwoord moet verschillen van het huidige wachtwoord.",
  "Not authenticated": "Niet aangemeld",
  "Password must be at least 8 characters and contain a letter and a number.": "Het wachtwoord moet minimaal 8 tekens bevatten, met een letter en een cijfer.",
  "Passwords do not match.": "De wachtwoorden komen niet overeen.",
  "Report not found": "Rapport niet gevonden",
  "Service request not found": "Serviceaanvraag niet gevonden",
  "Submission not found": "Inzending niet gevonden",
  "This reset link is invalid or has expired.": "Deze resetlink is ongeldig of verlopen.",
  "Too many failed attempts. Please try again in 15 minutes.": "Te veel mislukte pogingen. Probeer het over 15 minuten opnieuw.",
  "Unable to upload this file. Please make sure it is a PDF.": "Dit bestand kan niet worden geüpload. Zorg dat het een PDF is.",
  "Unauthorized": "Geen toegang",
  "Unknown assessment type": "Onbekend assessmenttype",
  "Unknown service": "Onbekende dienst",
  "User not found": "Gebruiker niet gevonden",
  "You do not have permission to access this resource.": "U heeft geen toestemming om deze resource te openen.",
  "You must agree to the ESAIA Terms and Privacy Policy.": "U moet akkoord gaan met de ESAIA-voorwaarden en het privacybeleid.",
  "Your session has expired. Please log in again.": "Uw sessie is verlopen. Log opnieuw in.",
  "for": "voor",
  "My Portal": "Mijn portaal",
  "Admin Portal": "Beheerportaal",
  "ERI completed": "ERI voltooid",
  "Website enquiry": "Website-aanvraag",
  "Anonymous": "Anoniem",
  "Saving...": "Opslaan...",
  "Language": "Taal",
  "Ethical Standards for Artificial Intelligence Assurance": "Ethische standaarden voor AI-assurance",
};
